// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/aircraft-flights/list',
    name: 'aircraft-flights-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/Aeronaves.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'product_aeronave',
    },
  },
  {
    path: '/aircraft-flights/update',
    name: 'aircraft-flights-update',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/form/Aeronaves.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'product_aeronave',
    },
  },
]

export default formTable
